// extracted by mini-css-extract-plugin
export default {"container":"bd_b","topSection":"bd_fn"};